import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { usePlanHasCustomizeCommunity } from "@circle-react/hooks/useIsCustomizeCommunity";
import { useThemeContext } from "@circle-react/providers/Theme";

const sidebarClasses = {
  inactive:
    "bg-transparent text-primary cursor-pointer focus-visible:bg-hover focus-visible:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary focus-visible:-outline-offset-2",
  activeWithBrandColor:
    "bg-brand text-brand-button focus:text-brand-button hover:text-brand-button cursor-default",
  activeWithThemeColor:
    "bg-c-active-item-color text-c-active-item-text-color focus:text-c-active-item-text-color hover:text-c-active-item-text-color cursor-default",
  unreadContent: "font-semibold",
} as const;

const inactiveHoverScopeClasses = {
  scoped:
    "has-[[data-hover-trigger]:hover]:bg-hover has-[[data-hover-trigger]:hover]:text-primary",
  direct: "hover:bg-hover hover:text-primary",
} as const;

export type InactiveSidebarNavLinkHoverScope =
  keyof typeof inactiveHoverScopeClasses;

export const useSidebarNavLinkClass = () => {
  const isCustomizeCommunity = usePlanHasCustomizeCommunity();
  const { currentTheme } = useThemeContext();

  const shouldUseActiveItemThemeColor =
    isCustomizeCommunity && currentTheme === "custom";

  const getActiveInactiveClasses = (
    isActive: boolean,
    inactiveHoverScope: InactiveSidebarNavLinkHoverScope = "direct",
  ) => {
    if (isActive) {
      return shouldUseActiveItemThemeColor
        ? sidebarClasses.activeWithThemeColor
        : sidebarClasses.activeWithBrandColor;
    }

    return classNames(
      sidebarClasses.inactive,
      inactiveHoverScopeClasses[inactiveHoverScope],
    );
  };

  const getUnreadClasses = (hasUnreadContent: boolean) =>
    hasUnreadContent ? sidebarClasses.unreadContent : "";

  return {
    getActiveInactiveClasses,
    getUnreadClasses,
  };
};
